module.exports = __webpack_public_path__ + "static/media/VisibilityOffIcon.337b5b2a.svg";